module.exports = __webpack_public_path__ + "img/ZEBU_LOGO.fb63f6f6.png";